import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=1f16e34f&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=ts&"
export * from "./TransactionsList.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=1f16e34f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16e34f",
  null
  
)

export default component.exports